import {
  TABLA_SECTION_PATHS,
  TABLA_SUB_SECTION_PATHS,
} from "./SectionRoutesConstants";

export const SIZE_COUNT = 10000;
export const PUB_NAME = "Tabla";
export const PUB_LANGUAGE = "en";
export const OLDEST_YEAR = 2020;
export const BASE_URL =
  (import.meta.env.VITE_WEB2_BASE_URL as string) || "https://www.tabla.com.sg";
export const CACHE_EXPIRY_TIME = 300;

const tablaSectionPaths: string[] = TABLA_SECTION_PATHS;
const tablaSubSectionPaths: string[] = TABLA_SUB_SECTION_PATHS;

export const SECTION_SITEMAP_PATHS: string[] = Array.from(
  new Set<string>(["/", ...tablaSectionPaths, ...tablaSubSectionPaths]),
);
